// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/skill/v1/skill.proto" (package "agency.skill.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * Skill represents an injectable context block (analogous to CLAUDE.md).
 *
 * @generated from protobuf message agency.skill.v1.Skill
 */
export interface Skill {
    /**
     * id uniquely identifies this skill.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * name is the human-readable skill name.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * description explains what the skill provides.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * tags are categorization labels for discovery.
     *
     * @generated from protobuf field: repeated string tags = 4
     */
    tags: string[];
    /**
     * categories are primary skill categories.
     *
     * @generated from protobuf field: repeated string categories = 5
     */
    categories: string[];
    /**
     * content is the skill content (markdown/text) injected into system prompt.
     *
     * @generated from protobuf field: string content = 6
     */
    content: string;
    /**
     * trust_level indicates the skill's trust level.
     *
     * @generated from protobuf field: agency.skill.v1.SkillTrustLevel trust_level = 7
     */
    trustLevel: SkillTrustLevel;
    /**
     * version is the skill version.
     *
     * @generated from protobuf field: string version = 8
     */
    version: string;
    /**
     * author is the skill author identifier.
     *
     * @generated from protobuf field: string author = 9
     */
    author: string;
    /**
     * created_at is when the skill was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 10
     */
    createdAt?: Timestamp;
    /**
     * updated_at is when the skill was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 11
     */
    updatedAt?: Timestamp;
    /**
     * enabled indicates if the skill is active.
     *
     * @generated from protobuf field: bool enabled = 12
     */
    enabled: boolean;
    /**
     * requires_sandbox forces sandbox execution for this skill.
     *
     * @generated from protobuf field: bool requires_sandbox = 13
     */
    requiresSandbox: boolean;
    /**
     * execution_timeout_seconds is the max execution time (if executable).
     *
     * @generated from protobuf field: int32 execution_timeout_seconds = 14
     */
    executionTimeoutSeconds: number;
    /**
     * dependencies are other skill IDs this skill requires.
     *
     * @generated from protobuf field: repeated string dependencies = 15
     */
    dependencies: string[];
    /**
     * metadata contains additional skill context.
     *
     * @generated from protobuf field: map<string, string> metadata = 16
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * SkillInput provides input to executable skills.
 *
 * @generated from protobuf message agency.skill.v1.SkillInput
 */
export interface SkillInput {
    /**
     * skill_id is the skill to execute.
     *
     * @generated from protobuf field: string skill_id = 1
     */
    skillId: string;
    /**
     * session_id is the session context.
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * parameters are execution parameters.
     *
     * @generated from protobuf field: map<string, string> parameters = 3
     */
    parameters: {
        [key: string]: string;
    };
    /**
     * context is the execution context (messages, state, etc).
     *
     * @generated from protobuf field: map<string, string> context = 4
     */
    context: {
        [key: string]: string;
    };
}
/**
 * SkillOutput is the result of executable skill execution.
 *
 * @generated from protobuf message agency.skill.v1.SkillOutput
 */
export interface SkillOutput {
    /**
     * skill_id is the executed skill.
     *
     * @generated from protobuf field: string skill_id = 1
     */
    skillId: string;
    /**
     * session_id is the session context.
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * content is the skill output content.
     *
     * @generated from protobuf field: string content = 3
     */
    content: string;
    /**
     * success indicates if execution succeeded.
     *
     * @generated from protobuf field: bool success = 4
     */
    success: boolean;
    /**
     * error_message describes failures.
     *
     * @generated from protobuf field: string error_message = 5
     */
    errorMessage: string;
    /**
     * execution_time_ms is the execution duration.
     *
     * @generated from protobuf field: int64 execution_time_ms = 6
     */
    executionTimeMs: bigint;
    /**
     * metadata contains additional output context.
     *
     * @generated from protobuf field: map<string, string> metadata = 7
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * SkillValidationResult is the result of skill validation.
 * ValidationError represents a structured validation error.
 *
 * @generated from protobuf message agency.skill.v1.ValidationError
 */
export interface ValidationError {
    /**
     * field is the field that failed validation.
     *
     * @generated from protobuf field: string field = 1
     */
    field: string;
    /**
     * check is the validation check that failed (e.g., "schema", "content_policy", "size_limit").
     *
     * @generated from protobuf field: string check = 2
     */
    check: string;
    /**
     * reason explains why the validation failed.
     *
     * @generated from protobuf field: string reason = 3
     */
    reason: string;
}
/**
 * @generated from protobuf message agency.skill.v1.SkillValidationResult
 */
export interface SkillValidationResult {
    /**
     * skill_id is the validated skill.
     *
     * @generated from protobuf field: string skill_id = 1
     */
    skillId: string;
    /**
     * valid indicates if the skill is valid.
     *
     * @generated from protobuf field: bool valid = 2
     */
    valid: boolean;
    /**
     * errors are structured validation errors.
     *
     * @generated from protobuf field: repeated agency.skill.v1.ValidationError errors = 3
     */
    errors: ValidationError[];
    /**
     * warnings are non-fatal validation warnings.
     *
     * @generated from protobuf field: repeated string warnings = 4
     */
    warnings: string[];
    /**
     * validated_at is when validation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp validated_at = 5
     */
    validatedAt?: Timestamp;
}
/**
 * SkillMatchRequest requests skill matching based on criteria.
 *
 * @generated from protobuf message agency.skill.v1.SkillMatchRequest
 */
export interface SkillMatchRequest {
    /**
     * tags are required tags.
     *
     * @generated from protobuf field: repeated string tags = 1
     */
    tags: string[];
    /**
     * categories are required categories.
     *
     * @generated from protobuf field: repeated string categories = 2
     */
    categories: string[];
    /**
     * min_trust_level is the minimum required trust level.
     *
     * @generated from protobuf field: agency.skill.v1.SkillTrustLevel min_trust_level = 3
     */
    minTrustLevel: SkillTrustLevel;
    /**
     * enabled_only filters to enabled skills.
     *
     * @generated from protobuf field: bool enabled_only = 4
     */
    enabledOnly: boolean;
    /**
     * limit is the maximum results to return.
     *
     * @generated from protobuf field: int32 limit = 5
     */
    limit: number;
}
/**
 * SkillMatchResponse returns matching skills.
 *
 * @generated from protobuf message agency.skill.v1.SkillMatchResponse
 */
export interface SkillMatchResponse {
    /**
     * skills are the matching skills.
     *
     * @generated from protobuf field: repeated agency.skill.v1.Skill skills = 1
     */
    skills: Skill[];
    /**
     * total_count is the total matching skills.
     *
     * @generated from protobuf field: int32 total_count = 2
     */
    totalCount: number;
}
/**
 * SkillSignature represents a cryptographic signature for skill authenticity.
 *
 * @generated from protobuf message agency.skill.v1.SkillSignature
 */
export interface SkillSignature {
    /**
     * skill_id is the signed skill identifier.
     *
     * @generated from protobuf field: string skill_id = 1
     */
    skillId: string;
    /**
     * signature is the cryptographic signature bytes.
     *
     * @generated from protobuf field: bytes signature = 2
     */
    signature: Uint8Array;
    /**
     * algorithm is the signature algorithm (e.g., "ed25519", "rsa-sha256").
     *
     * @generated from protobuf field: string algorithm = 3
     */
    algorithm: string;
    /**
     * signer_id identifies the signer (public key ID or certificate ID).
     *
     * @generated from protobuf field: string signer_id = 4
     */
    signerId: string;
    /**
     * signed_at is when the signature was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp signed_at = 5
     */
    signedAt?: Timestamp;
    /**
     * public_key is the signer's public key (optional, may be fetched separately).
     *
     * @generated from protobuf field: bytes public_key = 6
     */
    publicKey: Uint8Array;
    /**
     * metadata contains additional signature context.
     *
     * @generated from protobuf field: map<string, string> metadata = 7
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * SkillTrustLevel defines the trust level of a skill.
 *
 * @generated from protobuf enum agency.skill.v1.SkillTrustLevel
 */
export enum SkillTrustLevel {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SKILL_TRUST_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * UNTRUSTED skills are sandboxed with strict validation.
     *
     * @generated from protobuf enum value: SKILL_TRUST_LEVEL_UNTRUSTED = 1;
     */
    UNTRUSTED = 1,
    /**
     * COMMUNITY skills are from verified community sources.
     *
     * @generated from protobuf enum value: SKILL_TRUST_LEVEL_COMMUNITY = 2;
     */
    COMMUNITY = 2,
    /**
     * VERIFIED skills are from trusted publishers.
     *
     * @generated from protobuf enum value: SKILL_TRUST_LEVEL_VERIFIED = 3;
     */
    VERIFIED = 3,
    /**
     * OFFICIAL skills are from the platform provider.
     *
     * @generated from protobuf enum value: SKILL_TRUST_LEVEL_OFFICIAL = 4;
     */
    OFFICIAL = 4,
    /**
     * INTERNAL skills are organization-specific.
     *
     * @generated from protobuf enum value: SKILL_TRUST_LEVEL_INTERNAL = 5;
     */
    INTERNAL = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class Skill$Type extends MessageType<Skill> {
    constructor() {
        super("agency.skill.v1.Skill", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 4, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 5, name: "categories", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 6, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "524288" } } } },
            { no: 7, name: "trust_level", kind: "enum", T: () => ["agency.skill.v1.SkillTrustLevel", SkillTrustLevel, "SKILL_TRUST_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 8, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$" } } } },
            { no: 9, name: "author", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 10, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 11, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 12, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "requires_sandbox", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "execution_timeout_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 300, gte: 0 } } } },
            { no: 15, name: "dependencies", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 16, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } }
        ]);
    }
    create(value?: PartialMessage<Skill>): Skill {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.description = "";
        message.tags = [];
        message.categories = [];
        message.content = "";
        message.trustLevel = 0;
        message.version = "";
        message.author = "";
        message.enabled = false;
        message.requiresSandbox = false;
        message.executionTimeoutSeconds = 0;
        message.dependencies = [];
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<Skill>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Skill): Skill {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated string tags */ 4:
                    message.tags.push(reader.string());
                    break;
                case /* repeated string categories */ 5:
                    message.categories.push(reader.string());
                    break;
                case /* string content */ 6:
                    message.content = reader.string();
                    break;
                case /* agency.skill.v1.SkillTrustLevel trust_level */ 7:
                    message.trustLevel = reader.int32();
                    break;
                case /* string version */ 8:
                    message.version = reader.string();
                    break;
                case /* string author */ 9:
                    message.author = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 10:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* bool enabled */ 12:
                    message.enabled = reader.bool();
                    break;
                case /* bool requires_sandbox */ 13:
                    message.requiresSandbox = reader.bool();
                    break;
                case /* int32 execution_timeout_seconds */ 14:
                    message.executionTimeoutSeconds = reader.int32();
                    break;
                case /* repeated string dependencies */ 15:
                    message.dependencies.push(reader.string());
                    break;
                case /* map<string, string> metadata */ 16:
                    this.binaryReadMap16(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap16(map: Skill["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Skill["metadata"] | undefined, val: Skill["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.skill.v1.Skill.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Skill, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated string tags = 4; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.tags[i]);
        /* repeated string categories = 5; */
        for (let i = 0; i < message.categories.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.categories[i]);
        /* string content = 6; */
        if (message.content !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.content);
        /* agency.skill.v1.SkillTrustLevel trust_level = 7; */
        if (message.trustLevel !== 0)
            writer.tag(7, WireType.Varint).int32(message.trustLevel);
        /* string version = 8; */
        if (message.version !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.version);
        /* string author = 9; */
        if (message.author !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.author);
        /* google.protobuf.Timestamp created_at = 10; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool enabled = 12; */
        if (message.enabled !== false)
            writer.tag(12, WireType.Varint).bool(message.enabled);
        /* bool requires_sandbox = 13; */
        if (message.requiresSandbox !== false)
            writer.tag(13, WireType.Varint).bool(message.requiresSandbox);
        /* int32 execution_timeout_seconds = 14; */
        if (message.executionTimeoutSeconds !== 0)
            writer.tag(14, WireType.Varint).int32(message.executionTimeoutSeconds);
        /* repeated string dependencies = 15; */
        for (let i = 0; i < message.dependencies.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.dependencies[i]);
        /* map<string, string> metadata = 16; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.Skill
 */
export const Skill = new Skill$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillInput$Type extends MessageType<SkillInput> {
    constructor() {
        super("agency.skill.v1.SkillInput", [
            { no: 1, name: "skill_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "parameters", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "65536" } } } } } },
            { no: 4, name: "context", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1048576" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SkillInput>): SkillInput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.skillId = "";
        message.sessionId = "";
        message.parameters = {};
        message.context = {};
        if (value !== undefined)
            reflectionMergePartial<SkillInput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillInput): SkillInput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string skill_id */ 1:
                    message.skillId = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* map<string, string> parameters */ 3:
                    this.binaryReadMap3(message.parameters, reader, options);
                    break;
                case /* map<string, string> context */ 4:
                    this.binaryReadMap4(message.context, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SkillInput["parameters"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SkillInput["parameters"] | undefined, val: SkillInput["parameters"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.skill.v1.SkillInput.parameters");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap4(map: SkillInput["context"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SkillInput["context"] | undefined, val: SkillInput["context"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.skill.v1.SkillInput.context");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SkillInput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string skill_id = 1; */
        if (message.skillId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.skillId);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* map<string, string> parameters = 3; */
        for (let k of globalThis.Object.keys(message.parameters))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.parameters[k]).join();
        /* map<string, string> context = 4; */
        for (let k of globalThis.Object.keys(message.context))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.context[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.SkillInput
 */
export const SkillInput = new SkillInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillOutput$Type extends MessageType<SkillOutput> {
    constructor() {
        super("agency.skill.v1.SkillOutput", [
            { no: 1, name: "skill_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "524288" } } } },
            { no: 4, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 6, name: "execution_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 7, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SkillOutput>): SkillOutput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.skillId = "";
        message.sessionId = "";
        message.content = "";
        message.success = false;
        message.errorMessage = "";
        message.executionTimeMs = 0n;
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<SkillOutput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillOutput): SkillOutput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string skill_id */ 1:
                    message.skillId = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* string content */ 3:
                    message.content = reader.string();
                    break;
                case /* bool success */ 4:
                    message.success = reader.bool();
                    break;
                case /* string error_message */ 5:
                    message.errorMessage = reader.string();
                    break;
                case /* int64 execution_time_ms */ 6:
                    message.executionTimeMs = reader.int64().toBigInt();
                    break;
                case /* map<string, string> metadata */ 7:
                    this.binaryReadMap7(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: SkillOutput["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SkillOutput["metadata"] | undefined, val: SkillOutput["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.skill.v1.SkillOutput.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SkillOutput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string skill_id = 1; */
        if (message.skillId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.skillId);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* string content = 3; */
        if (message.content !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.content);
        /* bool success = 4; */
        if (message.success !== false)
            writer.tag(4, WireType.Varint).bool(message.success);
        /* string error_message = 5; */
        if (message.errorMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMessage);
        /* int64 execution_time_ms = 6; */
        if (message.executionTimeMs !== 0n)
            writer.tag(6, WireType.Varint).int64(message.executionTimeMs);
        /* map<string, string> metadata = 7; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.SkillOutput
 */
export const SkillOutput = new SkillOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidationError$Type extends MessageType<ValidationError> {
    constructor() {
        super("agency.skill.v1.ValidationError", [
            { no: 1, name: "field", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "check", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<ValidationError>): ValidationError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.field = "";
        message.check = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<ValidationError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidationError): ValidationError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string field */ 1:
                    message.field = reader.string();
                    break;
                case /* string check */ 2:
                    message.check = reader.string();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidationError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string field = 1; */
        if (message.field !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.field);
        /* string check = 2; */
        if (message.check !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.check);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.ValidationError
 */
export const ValidationError = new ValidationError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillValidationResult$Type extends MessageType<SkillValidationResult> {
    constructor() {
        super("agency.skill.v1.SkillValidationResult", [
            { no: 1, name: "skill_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "errors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ValidationError, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 4, name: "warnings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "2048" } } } } } },
            { no: 5, name: "validated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SkillValidationResult>): SkillValidationResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.skillId = "";
        message.valid = false;
        message.errors = [];
        message.warnings = [];
        if (value !== undefined)
            reflectionMergePartial<SkillValidationResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillValidationResult): SkillValidationResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string skill_id */ 1:
                    message.skillId = reader.string();
                    break;
                case /* bool valid */ 2:
                    message.valid = reader.bool();
                    break;
                case /* repeated agency.skill.v1.ValidationError errors */ 3:
                    message.errors.push(ValidationError.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string warnings */ 4:
                    message.warnings.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp validated_at */ 5:
                    message.validatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.validatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SkillValidationResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string skill_id = 1; */
        if (message.skillId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.skillId);
        /* bool valid = 2; */
        if (message.valid !== false)
            writer.tag(2, WireType.Varint).bool(message.valid);
        /* repeated agency.skill.v1.ValidationError errors = 3; */
        for (let i = 0; i < message.errors.length; i++)
            ValidationError.internalBinaryWrite(message.errors[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated string warnings = 4; */
        for (let i = 0; i < message.warnings.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.warnings[i]);
        /* google.protobuf.Timestamp validated_at = 5; */
        if (message.validatedAt)
            Timestamp.internalBinaryWrite(message.validatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.SkillValidationResult
 */
export const SkillValidationResult = new SkillValidationResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillMatchRequest$Type extends MessageType<SkillMatchRequest> {
    constructor() {
        super("agency.skill.v1.SkillMatchRequest", [
            { no: 1, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 2, name: "categories", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 3, name: "min_trust_level", kind: "enum", T: () => ["agency.skill.v1.SkillTrustLevel", SkillTrustLevel, "SKILL_TRUST_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 4, name: "enabled_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<SkillMatchRequest>): SkillMatchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tags = [];
        message.categories = [];
        message.minTrustLevel = 0;
        message.enabledOnly = false;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<SkillMatchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillMatchRequest): SkillMatchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string tags */ 1:
                    message.tags.push(reader.string());
                    break;
                case /* repeated string categories */ 2:
                    message.categories.push(reader.string());
                    break;
                case /* agency.skill.v1.SkillTrustLevel min_trust_level */ 3:
                    message.minTrustLevel = reader.int32();
                    break;
                case /* bool enabled_only */ 4:
                    message.enabledOnly = reader.bool();
                    break;
                case /* int32 limit */ 5:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SkillMatchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string tags = 1; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.tags[i]);
        /* repeated string categories = 2; */
        for (let i = 0; i < message.categories.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.categories[i]);
        /* agency.skill.v1.SkillTrustLevel min_trust_level = 3; */
        if (message.minTrustLevel !== 0)
            writer.tag(3, WireType.Varint).int32(message.minTrustLevel);
        /* bool enabled_only = 4; */
        if (message.enabledOnly !== false)
            writer.tag(4, WireType.Varint).bool(message.enabledOnly);
        /* int32 limit = 5; */
        if (message.limit !== 0)
            writer.tag(5, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.SkillMatchRequest
 */
export const SkillMatchRequest = new SkillMatchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillMatchResponse$Type extends MessageType<SkillMatchResponse> {
    constructor() {
        super("agency.skill.v1.SkillMatchResponse", [
            { no: 1, name: "skills", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Skill, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<SkillMatchResponse>): SkillMatchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.skills = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<SkillMatchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillMatchResponse): SkillMatchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.skill.v1.Skill skills */ 1:
                    message.skills.push(Skill.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SkillMatchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.skill.v1.Skill skills = 1; */
        for (let i = 0; i < message.skills.length; i++)
            Skill.internalBinaryWrite(message.skills[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.SkillMatchResponse
 */
export const SkillMatchResponse = new SkillMatchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillSignature$Type extends MessageType<SkillSignature> {
    constructor() {
        super("agency.skill.v1.SkillSignature", [
            { no: 1, name: "skill_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "signature", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { minLen: "1", maxLen: "1024" } } } },
            { no: 3, name: "algorithm", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 4, name: "signer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "signed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "public_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { maxLen: "4096" } } } },
            { no: 7, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SkillSignature>): SkillSignature {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.skillId = "";
        message.signature = new Uint8Array(0);
        message.algorithm = "";
        message.signerId = "";
        message.publicKey = new Uint8Array(0);
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<SkillSignature>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillSignature): SkillSignature {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string skill_id */ 1:
                    message.skillId = reader.string();
                    break;
                case /* bytes signature */ 2:
                    message.signature = reader.bytes();
                    break;
                case /* string algorithm */ 3:
                    message.algorithm = reader.string();
                    break;
                case /* string signer_id */ 4:
                    message.signerId = reader.string();
                    break;
                case /* google.protobuf.Timestamp signed_at */ 5:
                    message.signedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.signedAt);
                    break;
                case /* bytes public_key */ 6:
                    message.publicKey = reader.bytes();
                    break;
                case /* map<string, string> metadata */ 7:
                    this.binaryReadMap7(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: SkillSignature["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SkillSignature["metadata"] | undefined, val: SkillSignature["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.skill.v1.SkillSignature.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SkillSignature, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string skill_id = 1; */
        if (message.skillId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.skillId);
        /* bytes signature = 2; */
        if (message.signature.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.signature);
        /* string algorithm = 3; */
        if (message.algorithm !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.algorithm);
        /* string signer_id = 4; */
        if (message.signerId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.signerId);
        /* google.protobuf.Timestamp signed_at = 5; */
        if (message.signedAt)
            Timestamp.internalBinaryWrite(message.signedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bytes public_key = 6; */
        if (message.publicKey.length)
            writer.tag(6, WireType.LengthDelimited).bytes(message.publicKey);
        /* map<string, string> metadata = 7; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.skill.v1.SkillSignature
 */
export const SkillSignature = new SkillSignature$Type();
